import Point from '@/models/Point'

export class PointTransformer {
    transform (data) {
        return new Point(data.lat, data.lng)
    }
}
